<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Asistencia de personal</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <BaseInput v-model="search" label="Buscar" append-icon="mdi-magnify" style="max-width: 300px" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="personal" class="transparent">
                  <template v-slot:[`item.nombre`]="{ item }">
                    {{ getFullName(item) }}
                  </template>
                  <template v-slot:[`item.puesto`]="{ item }">
                    {{
                      item.CatPuestoDependencia && item.CatPuestoDependencia.catPuesto
                        ? item.CatPuestoDependencia.catPuesto.title
                        : ''
                    }}
                  </template>
                  <template v-slot:[`item.CUP`]="{ item }">
                    <span>
                      {{ item.CUP ? item.CUP : 'Sin datos' }}
                    </span>
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-card-account-details-outline"
                              :elevation="8"
                              :to="{
                                name: 'enlace.expedientePersonalSection',
                                params: { id: item.idPersonal || item.id },
                              }"
                            />
                          </span>
                        </template>
                        <span>Ver Expediente</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-account-plus"
                              :elevation="8"
                              @click="openRegistroAsistenciaDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Registrar Asistencia</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              :elevation="8"
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-list-box-outline"
                              @click="openListadoArmasDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Listado de armas</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import BaseInput from '../base/BaseInput.vue'
import IconButton from '../base/IconButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  components: {
    IconButton,
    BaseInput,
  },
  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'nombre', width: '200px' },
        { text: 'Puesto', value: 'puesto', width: '150px' },
        { text: 'CUIP', value: 'CUIP', width: '150px' },
        { text: 'CUP', value: 'CUP', width: '150px' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: '150px' },
      ],
      loading: false,
      search: '',
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personalOriginal: 'getPersonalWithArmas',
    }),
    personal() {
      /**
       *  if (!this.search) return this.personalOriginal
      const searchLower = this.search.toLowerCase()
      return this.personalOriginal.filter((item) => {
        const nombreCompleto = this.getFullName(item).toLowerCase()
        const puesto =
          item.CatPuestoDependencia && item.CatPuestoDependencia.catPuesto
            ? item.CatPuestoDependencia.catPuesto.title.toLowerCase()
            : ''
        return nombreCompleto.includes(searchLower) || puesto.includes(searchLower)
      })
       * 
       */
      return [
        {
          adjuntoCup:
            'https://edofza.eoninnovaction.com/CICG_SEG/ESTADO_FUERZA/Files/Documentos/EAE1B53B751F0F78AFFA0ACB1B9DC7CE0ADB88F8.PDF',
          amaterno: 'AVILA',
          antiguedad: '',
          apaterno: 'CORONA',
          aptoSNPSP: false,
          capturo: '',
          cartillaMilitar: 'C-9786266',
          CatArea: {
            CatRamaDependencia: {
              CatDependencia: {
                catInstancia: {
                  id: 1,
                  title: 'SEGURIDAD PUBLICA',
                },
                CatTipoAmbito: null,
                domicilio: '',
                fk_idCatTipoAmbito: 0,
                fk_idInstancia: 1,
                id: 2,
                nombre: 'POLICIA ESTATAL',
                telefono: '',
                titular: '',
              },
              fk_idDependencia: 2,
              id: 19,
              numeroElementos: 0,
              ramaDependencia: 'DIRECCIÓN DESARROLLO POLICIAL',
            },
            fk_idCatRamaDependencia: 19,
            id: 68,
            nombre: 'DESPACHO DIRECCION DE DESARROLLO POLICIAL',
          },
          categoriaPuestoCnca: '',
          categorizacion: '',
          CatEstadoCivil: {
            id: 2,
            title: 'Casado/a',
          },
          CatEstatus: {
            id: 1,
            title: 'ACTIVO',
          },
          CatEstGradoHomologado: null,
          CatGrupoSanguineo: {
            id: 5,
            title: 'O+',
          },
          CatHabilitado: null,
          CatMotivoBaja: null,
          CatMunicipioNacimiento: {
            catEstado: {
              id: 29,
              title: 'TLAXCALA',
            },
            claveINEGI: '033',
            fk_idEstado: 29,
            id: 2072,
            nombre: '  TLAXCALA',
          },
          CatMunicipioRadica: {
            catEstado: {
              id: 29,
              title: 'TLAXCALA',
            },
            claveINEGI: '036',
            fk_idEstado: 29,
            id: 2075,
            nombre: '  TOTOLAC',
          },
          CatNivel: null,
          CatPuestoDependencia: {
            catDependencia: {
              catInstancia: {
                id: 1,
                title: 'SEGURIDAD PUBLICA',
              },
              CatTipoAmbito: null,
              domicilio: '',
              fk_idCatTipoAmbito: 0,
              fk_idInstancia: 1,
              id: 2,
              nombre: 'POLICIA ESTATAL',
              telefono: '',
              titular: '',
            },
            catPuesto: {
              id: 51,
              puesto: '176-COMISARIO',
              title: 'COMISARIO',
            },
            CatTipoPuesto: {
              id: 1,
              title: 'Administrativo',
            },
            fk_idCatTipoPuesto: 1,
            fk_idDependencia: 2,
            fk_idPuesto: 51,
            id: 51,
          },
          CatRamaDependencia: {
            CatDependencia: {
              catInstancia: {
                id: 1,
                title: 'SEGURIDAD PUBLICA',
              },
              CatTipoAmbito: null,
              domicilio: '',
              fk_idCatTipoAmbito: 0,
              fk_idInstancia: 1,
              id: 2,
              nombre: 'POLICIA ESTATAL',
              telefono: '',
              titular: '',
            },
            fk_idDependencia: 2,
            id: 19,
            numeroElementos: 0,
            ramaDependencia: 'DIRECCIÓN DESARROLLO POLICIAL',
          },
          CatSexo: {
            id: 1,
            title: 'Masculino',
          },
          CatSubArea: {
            CatArea: {
              CatRamaDependencia: {
                CatDependencia: {
                  catInstancia: {
                    id: 1,
                    title: 'SEGURIDAD PUBLICA',
                  },
                  CatTipoAmbito: null,
                  domicilio: '',
                  fk_idCatTipoAmbito: 0,
                  fk_idInstancia: 1,
                  id: 2,
                  nombre: 'POLICIA ESTATAL',
                  telefono: '',
                  titular: '',
                },
                fk_idDependencia: 2,
                id: 19,
                numeroElementos: 0,
                ramaDependencia: 'DIRECCIÓN DESARROLLO POLICIAL',
              },
              fk_idCatRamaDependencia: 19,
              id: 68,
              nombre: 'DESPACHO DIRECCION DE DESARROLLO POLICIAL',
            },
            fk_idCatArea: 68,
            id: 73,
            nombre: 'DESPACHO DIRECCION DE DESARROLLO POLICIAL',
          },
          CatSubSede: null,
          CatTipoFuncion: null,
          CatTipoNacionalidad: {
            id: 1,
            title: 'Nacimiento',
          },
          CatTipoRecurso: null,
          CatTurno: null,
          cib: '',
          claveIne: 'CRAVDV86080229H700',
          Contacto: {
            correoElectronico: 'd.avo.0886@gmail.com',
            Direccion: {
              calle: 'PRIVADA DEL RIO ZAHUAPAN # 115 INT. 702',
              CatMunicipio: {
                catEstado: {
                  id: 29,
                  title: 'TLAXCALA',
                },
                claveINEGI: '036',
                fk_idEstado: 29,
                id: 2075,
                nombre: '  TOTOLAC',
              },
              colonia: 'SAN MIGUEL TLAMAHUCO',
              cp: '90820',
              entrecalles: '',
              entrecalles2: '',
              ext: '115',
              fk_idMunicipio: 2075,
              int: '',
              lat: '0.0',
              lgt: '0.0',
              localidad: '',
              referencias: '',
            },
            fk_idDireccion: 300,
            idDatoContacto: 300,
            telefonoCelular: '2461580313/',
            telefonoFijo: '',
            validacionCorreo: false,
          },
          criticidadPuestoOperativo: '',
          CUIP: 'COAD860802H294417634',
          CUP: '2T25E33RO1223/0136072/CORL680426P63/33',
          curp: 'COAD860802HTLRVV02',
          estarLn: '',
          estatura: 0,
          estatusSnsp: '',
          examenC3Mes: 'JULIO',
          expedicionCartaNoAdeudo: false,
          fechaBaja: '',
          fechaCaptura: '',
          fechaIngreso: '',
          fechaIngresoEdoFza: '',
          fechaNacimiento: '2/8/1986',
          fechaRegistro: '',
          fk_idCatArea: 68,
          fk_idCatGradoHomologado: 0,
          fk_idCatGrupoSanguineo: 5,
          fk_idCatHabilitado: 0,
          fk_idCatNivel: 0,
          fk_idCatSubArea: 73,
          fk_idCatTipoFuncion: 0,
          fk_idCatTipoRecurso: 0,
          fk_idCatTurno: 0,
          fk_idContactoPersonal: 300,
          fk_idEstadoCivil: 2,
          fk_idEstatus: 1,
          fk_idMotivoBaja: 0,
          fk_idMunicipioNacimiento: 2072,
          fk_idMunicipioRadica: 2075,
          fk_idPerfil: 0,
          fk_idPuestoDependencia: 51,
          fk_idRamaDependencia: 19,
          fk_idSexo: 1,
          fk_idSubsede: 0,
          fk_idTipoNacionalidad: 1,
          foto: 'https://edofza.eoninnovaction.com/CICG_SEG/ESTADO_FUERZA/Files/Fotografia/FRENTE_COAD860802H294417634.JPG',
          funcional: '',
          funciones: '',
          idPersonal: 328,
          jerarquiaPuesto: '',
          lentes: false,
          licenciaColectivaPortacionArma: '',
          licenciaConducir: '',
          mediafiliacion: [],
          nacionalidad: 'MEXICANA',
          nombre: 'DAVID',
          nsmi: '',
          nss: '',
          numeroCredencial: '183',
          observaciones: '',
          observacionesC3: 'APROBADO',
          pasaporte: '',
          password: '',
          peso: 0,
          plaza: '',
          portacionArma: false,
          rangoCategoria: '',
          rfc: 'COAD860802MI5',
          segundoNombre: '',
          seniasParticulares: [],
          smn: '',
          sueldoBase: '44221.16',
          sueldoNeto: '29805.44',
          unidadAnalisisTactico: '',
          unidadInvestigacion: '',
          unidadOperaciones: '',
          vigenciaAnio: 2025,
          vigenciaCompetenciasBasicas: '2/2/2025',
          vigenciaCup: '5/5/2025',
          vigenciaEvaluacionC3: '1/1/2025',
          vigenciaFormacionInicial: '1/2/2021',
          vigenciaLicencia: '',
          vigenciaPasaporte: '',
          vigenciaVisa: '',
          visa: '',
        },
      ]
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),

    getFullName(person) {
      if (!person) return ''
      if (person.segundoNombre == '') {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre
      } else {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre + ' ' + person.segundoNombre
      }
    },
    openRegistroAsistenciaDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.REGISTRAR_ASISTENCIA,
        props: { selectedPersonal: item },
      })
    },
    openListadoArmasDialog(item) {
      const personalId = item.idPersonal || item.id
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.LISTADO_DE_ARMAS,
        props: { selectedPersonal: { ...item, idPersonal: personalId } },
      })
    },
  },
  created() {
    this.$store.dispatch('personal/fetchPersonalWithArmas')
  },
}
</script>
